import React from 'react'
import PropTypes from 'prop-types'
import { Typography, Box } from '@material-ui/core'

import { SECONDARY, CLOSE } from 'app/constants/button'

import ContainedButton from 'app/componentV4/Button/ContainedButton'
import OutlinedButtons from 'app/componentV4/Button/OutlinedButtons'
import PanelsIllustrationMSG from 'app/componentV4/Panels/IllustrationMSG'

import { step } from './constants'

const VerificationApproach = (props) => {
  const { email = '', onSubmit = () => {} } = props

  return (
    <>
      <PanelsIllustrationMSG
        isClickBack={true}
        onBack={() => onSubmit(step.isLogin)}
      >
        <div className="flex justify-center items-center h-full">
          <div className="w-full">
            {/* Header */}
            <Box className="rounded-8 py-5 px-10 bg-primary-200">
              <Typography className="text-16 text-primary text-center">
                {'Signing In with'}
                {/* {formatMessage({ id: 'Signing In with' })} */}
              </Typography>
              <Typography className="text-16 font-500 text-primary text-center break-all">
                {email}
              </Typography>
            </Box>

            <div className="flex items-center my-10">
              <div className="flex-1 border-t border-primary-350"></div>
              <Typography className="text-16 text-primary-300 text-center mx-5">
                {'Select your option to sign in'}
                {/* {formatMessage({ id: 'Select your option to sign in' })} */}
              </Typography>
              <div className="flex-1 border-t border-primary-350"></div>
            </div>

            <OutlinedButtons
              type="submit"
              id="login-password-input"
              color={CLOSE}
              className="w-full h-48"
              onClick={() => onSubmit(step.isPassword)}
            >
              {'Enter Password'}
              {/* {formatMessage({
                id: 'Enter Password',
              })} */}
            </OutlinedButtons>

            <div className="flex items-center my-10">
              <div className="flex-1 border-t border-primary-350"></div>
              <Typography className="text-16 text-primary-300 text-center mx-5">
                {'or passwordless'}
                {/* {formatMessage({ id: 'or passwordless' })} */}
              </Typography>
              <div className="flex-1 border-t border-primary-350"></div>
            </div>

            <ContainedButton
              type="submit"
              id="sign-in-via-otp"
              color={SECONDARY}
              className="w-full h-48"
              onClick={() => onSubmit(step.isOTP)}
            >
              {'Sign In via OTP'}
              {/* {formatMessage({
                id: 'Sign In via OTP',
              })} */}
            </ContainedButton>
          </div>
        </div>
      </PanelsIllustrationMSG>
    </>
  )
}

VerificationApproach.propTypes = {
  email: PropTypes.string,
  onSubmit: PropTypes.func,
}

export default VerificationApproach
